// Detail endpoints keep jsonb Record<lang, string> intact so per-locale
// edit forms can bind to value[lang] directly. For display contexts that
// need a single string, pick the active locale with an `en` fallback.
export const pickLocale = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any,
  lang: string | null | undefined
): string => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  const key = lang ?? 'en';

  return value[key] ?? value.en ?? '';
};
